import { handle } from 'redux-pack';
import { PhotoSessionSummary } from 'models/PhotoSessionSummary';
import { logUncaught } from 'utils/log';

const makePhotoSessionList = (photoSessionsList, photoSessionGroupedByDate) =>
  [
    ...photoSessionsList,
    ...(photoSessionGroupedByDate.pendingList.map(PhotoSessionSummary.createFrom)),
  ];

export const getStarted = (photoSessions) =>
  photoSessions.reduce(makePhotoSessionList, []);

export const handleStartedPhotoSessions = (prevState, action, error) => {
  if (error) {
    const statusCodes = action.payload.response && action.payload.response.status;

    logUncaught(
      new Error('[Failure fetching started photo sessions]'),
      {
        state: prevState,
        payload: action.payload,
      }
    );

    return statusCodes === 403
      ? prevState
      : {
        ...prevState,
        showStartedListError: true,
        hasFetchedStartedPhotoSessions: true,
      };
  }

  return {
    ...prevState,
    started: getStarted(action.payload.pending),
    showStartedListError: false,
    hasFetchedStartedPhotoSessions: true,
  };
};

export const handleStartedPhotoSessionsLifecycle = (action) => ({
  success: (prevState) => handleStartedPhotoSessions(prevState, action, false),
  failure: (prevState) => handleStartedPhotoSessions(prevState, action, true),
});

export const addStartedPhotoSessionsToState = (state, action) =>
  handle(
    state,
    action,
    handleStartedPhotoSessionsLifecycle(action)
  );
